<template>
  <div class="credit-card container-card mB20">
            
      <div id="card-element">
        <!-- a Stripe Element will be inserted here. -->
      </div>
      
      <b-row>
        <b-col>
          <div id="cvc-element">
            <!-- a Stripe Element will be inserted here. -->
          </div>
        </b-col>
    
        <b-col>
          <div id="expiry-element">
            <!-- a Stripe Element will be inserted here. -->
          </div>
        </b-col>
      </b-row>

    <input id="cardHolder"
           v-model="card.name"
           :placeholder="$t('payment.nombre')"
           type="text"
           name="cardHolder"
           class="w100 mB5 mT5"
           required
           @change="checkName()"
           @keyup="checkName()" />

      <!-- Used to display form errors -->
      <div id="card-errors" role="alert"></div>
          
  </div>
</template>

<script>

export default {
  props: {
    card: {
      type: Object,
      default: () => {}
    },
    validName: {
      type: Boolean,
      default: false
    },
  },
  methods: {
    checkName() {
      this.$emit('update:validName', false)
      if (this.card.name && this.card.name.length > 0)
        this.$emit('update:validName', true)
    }
  }
}
</script>
<style lang="scss">
@import './credit-card-stripe.sass';
</style>
